<template>
  <div id="contestInformation">
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/infoPic/title1.png" alt="" />
      </div>
    </div>
    <div class="info-box">
      <ul class="info-list" v-if="data.list.length != 0">
        <li class="info-item" v-for="(item, index) in data.list" :key="index">
          <a :href="item.link">
            <el-image
              :src="item.coverUrl"
              class="info-image"
              :fit="'cover'"
              v-if="item.coverUrl != undefined"
            ></el-image>
            <div class="info-message">
              <div class="middle">
                <h2 class="info-title">{{ item.title }}</h2>
                <div class="desc">{{ item.description }}</div>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          v-if="pageInfo.total > 3"
          @current-change="getList"
          :currentPage="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          layout=" prev, pager, next"
          :total="pageInfo.total"
          style="text-aligin: right"
        >
        </el-pagination>
      </div>
    </div>
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/infoPic/title2.png" alt="" />
      </div>
    </div>
    <div class="question-box">
      <!-- <ul>
        <li class="question-item"></li>
        <li class="question-item"></li>
        <li class="other">其他问题加群问管理员</li>
      </ul> -->

      <img src="../assets/img/infoPic/question.png" alt="" />
    </div>
    <div class="title">
      <div class="title-content">
        <img src="../assets/img/infoPic/title3.png" alt="" />
      </div>
    </div>
    <div class="QRCode-box">
      <ul class="QRcodeList">
        <li class="QR-item">
          <el-image
            :src="require('../assets/img/infoPic/qqCode.png')"
            :fit="'cover'"
            class="QRCode-img"
          ></el-image>
          <div class="code-msg">
            <p>自由单元QQ群</p>
          </div>
        </li>
        <li class="QR-item">
          <el-image
            class="QRCode-img"
            :src="require('../assets/img/infoPic/WxCode.png')"
            :fit="'cover'"
          ></el-image>
          <div class="code-msg">
            <p>主题单元微信群</p>
          </div>
        </li>
        <li class="QR-item">
          <el-image
            class="QRCode-img"
            :src="require('../assets/img/infoPic/offBlog.png')"
            :fit="'cover'"
          ></el-image>
          <div class="code-msg">
            <p>明基设计显示器</p>
            <p>官方微博</p>
          </div>
        </li>
        <li class="QR-item">
          <el-image
            class="QRCode-img"
            :src="require('../assets/img/infoPic/littleWx.png')"
            :fit="'cover'"
          ></el-image>
          <div class="code-msg">
            <p>小助手微信</p>
          </div>
        </li>
        <li class="QR-item">
          <el-image
            class="QRCode-img"
            :src="require('../assets/img/infoPic/WechatAccount.png')"
            :fit="'cover'"
          ></el-image>
          <div class="code-msg">
            <p>明基色彩管理显示器</p>
            <p>微信公众号</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="footer-box">
      <div class="orgLink">
        <div
          class="link-item"
          v-for="(item, index) in logoList.list"
          :key="index"
        >
          <div class="link-item-name">{{ item.title }}</div>
          <div class="link">
            <a
              v-for="(item1, index) in item.data"
              :key="index"
              @click.stop="goLink(item1)"
            >
              <img
                :src="item1.logoSrc"
                alt=""
                :style="{ height: item1.height }"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="beian">
        <div class="beian-box">
          <div>
            <a href="https://beian.miit.gov.cn/" target="_blank">
              <span>沪ICP备17047194号-5</span>
            </a>
          </div>
          <div class="line"></div>
          <div>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050502000550"
              target="_blank"
            >
              <img src="../assets/img/ga_icon.png" alt="" />
              <span>苏公网安备32050502000550号</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import { listByPage } from "../utils/apis/newApi";
import { brandHit } from "../utils/apis/brandApi";
export default {
  name: "contestInformation",
  setup() {
    const pageInfo = reactive({
      pageNum: 1,
      pageSize: 3,
      total: 4,
    });
    const data = reactive({
      list: [],
    });

    const logoList = reactive({
      list: [
        {
          title: "主 办 方",
          data: [
            {
              name: "明基",
              logoSrc: require("../assets/img/infoPic/BenQ.png"),
              href: "https://s.tb.cn/c.0uNQBj",
              height: "23px",
            },
          ],
        },
        {
          title: "协 办 方",
          data: [
            {
              name: "CG模型网",
              logoSrc: require("../assets/img/infoPic/moxing.png"),
              href: "https://www.cgmodel.com/",
              height: "26px",
            },
            {
              name: "蓝铅笔",
              logoSrc: require("../assets/img/infoPic/lanqianbi.png"),
              href: "https://www.lanqb.com/",
              height: "27px",
            },
            {
              name: "Wuhu",
              logoSrc: require("../assets/img/infoPic/Wuhu.png"),
              href: "https://weibo.com/u/5836279440",
              height: "45px",
            },
            {
              name: "GGAC",
              logoSrc: require("../assets/img/infoPic/GGAC.png"),
              href: "https://www.ggac.com/v2/home",
              height: "33px",
            },
          ],
        },
        {
          title: "联合品牌",
          data: [
            {
              name: "Pantone",
              logoSrc: require("../assets/img/infoPic/pantone.png"),
              href: "https://pantonecn.com",
              height: "44px",
            },
            {
              name: "CBS",
              logoSrc: require("../assets/img/infoPic/colebrook.png"),
              href: "https://mall.jd.com/view_page-257315110.html",
              height: "34px",
            },
            {
              name: "赫曼米勒",
              logoSrc: require("../assets/img/infoPic/herman.png"),
              href: "https://hermanmiller.tmall.com/",
              height: "27px",
            },
            {
              name: "绘王",
              logoSrc: require("../assets/img/infoPic/huion.png"),
              href: "https://store.huion.cn/",
              height: "24px",
            },
            {
              name: "ikbc",
              logoSrc: require("../assets/img/infoPic/ikbc.png"),
              href: "http://www.ikbc.com.cn",
              height: "28px",
            },
            {
              name: "金士顿",
              logoSrc: require("../assets/img/infoPic/kingstone.png"),
              href: "https://www.kingston.com/cn",
              height: "23px",
            },
          ],
        },
        {
          title: "支持单位",
          data: [
            {
              name: "ill",
              logoSrc: require("../assets/img/infoPic/ihdt.png"),
              href: "http://c4datc.com",
              height: "40px",
            },
            {
              name: "AD518",
              logoSrc: require("../assets/img/infoPic/ad518.png"),
              href: "http://www.ad518.com",
              height: "20px",
            },
            {
              name: "CDBC",
              logoSrc: require("../assets/img/infoPic/cdbc.png"),
              href: "https://weibo.com/207979150/",
              height: "35px",
            },
            {
              name: "涂鸦王国",
              logoSrc: require("../assets/img/infoPic/tuya.png"),
              href: "https://www.gracg.com/",
              height: "25px",
            },
          ],
        },
        {
          title: "字体支持",
          data: [
            {
              name: "造字工房",
              logoSrc: require("../assets/img/infoPic/zaozi.png"),
              href: "http://makefont.com",
              height: "40px",
            },
          ],
        },
      ],
    });

    getList(1);

    //获取列表
    function getList(value) {
      console.log(pageInfo.pageNum);
      pageInfo.pageNum = value;
      listByPage({
        pageNum: pageInfo.pageNum,
        pageSize: pageInfo.pageSize,
      }).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          data.list = res.data.data.list;
          pageInfo.total = res.data.data.total;
        }
      });
    }
    function goLink(item) {
      console.log(item);
      brandHit({ brand: item.name }).then((res) => {
        if (res.data.code === 200) {
          window.location.href = item.href;
        }
      });
    }
    return {
      pageInfo,
      data,
      getList,
      logoList,
      goLink,
    };
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTCHJW";
  src: url("../assets/fonts/FZLTCHJW.TTF") format("truetype");
}
@font-face {
  font-family: "FZLTHJW";
  src: url("../assets/fonts/FZLTHJW.TTF") format("truetype");
}
#contestInformation {
  padding-top: 116px;
  background-image: url("../assets/img/infoPic/bg.png");
  background-size: cover;
  background-position: center;
  .title {
    // height: 70px;
    margin-bottom: 72px;

    .title-content {
      text-align: center;
      // width: 240px;
      margin: 0 auto;
      // background-color: #94282e;
      line-height: 82px;
      height: 82px;

      color: #fff;
      font-size: 36px;
      font-weight: bold;
    }
  }
  .info-box {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 116px;
    .info-list {
      padding-bottom: 70px;
    }
    .info-item {
      a {
        display: flex;
        height: 258px;
        margin-bottom: 52px;
        text-decoration: none;
        color: #160202;
        .info-image {
          flex-shrink: 0;
          width: 418px;
          height: 258px;
          cursor: pointer;
        }
        .info-message {
          flex: 1;
          padding-left: 102px;
          max-width: calc(100% - 418px);
          position: relative;
          .middle {
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            width: calc(100% - 102px);
          }
          .info-title {
            // margin-top: 100px;
            margin-bottom: 15px;
            font-size: 30px;
          }
          .desc {
            color: #6c6c6c;
            font-size: 16px;
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis; //文本溢出显示省略号
            white-space: nowrap; //文本不会换行
          }
        }
      }
    }
    .info-item:last-child {
      margin-bottom: 0px;
    }
    .pagination {
      // height: 16px;
      text-align: center;
    }
  }
  .question-box {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 116px;
    text-align: center;
    ul {
      padding: 0 213px;
      .question-item {
        height: 108px;
        margin-bottom: 22px;
        background-color: #c9caca;
      }
      .other {
        margin-bottom: 0px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 20px;
        color: #373131;
        font-weight: bold;
        background-color: #c9caca;
      }
    }
  }
  .QRCode-box {
    height: 270px;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 72px;
  }
  .QRcodeList {
    display: flex;
    font-size: 0px;
    justify-content: space-between;

    .QR-item {
      margin-right: 20px;
      .QRCode-img {
        height: 200px;
        width: 200px;
        box-shadow: 6px 6px 20px 0px rgba(120, 89, 67, 0.5);
      }
      .code-msg {
        margin-top: 22px;
        line-height: 28px;
        font-size: 20px;
        font-family: "FZLTCHJW";

        text-align: center;
        color: #481c03;
      }
    }
    .QR-item:last-child {
      margin-right: 0px;
    }
  }
  .footer-box {
    // height: 330px;
    box-sizing: border-box;
    .orgLink {
      background-color: #272727;
      height: 378px;
    }
  }
  .orgLink {
    padding-top: 72px;
    padding-bottom: 72px;
    :nth-child(5) {
        .link-item-name {
          transform: translateY(6px);
        }
      }
    .link-item {
      overflow: hidden;
      width: 761px;
      margin: 0 auto;
      margin-bottom: 25px;
      .link-item-name {
        float: left;
        line-height: 45px;
        width: 85px;
        font-family: "FZLTHJW";
        font-size: 20px;
        color: #fff;
        text-align-last: justify;
        text-align: justify;
      }
      .link {
        margin-left: 132px;
        line-height: 45px;
        font-size: 0px;

        a {
          display: inline-block;
          line-height: 45px;
          margin-right: 27px;
          cursor: pointer;
          img {
            vertical-align: middle;
          }
        }
      }
    }
  }
  .beian {
    // height: 174px;
    // line-height: 174px;
    text-align: center;
    color: #7e3e34;
    padding-top: 20px;
    .beian-box {
      padding: 12px 0 13px;
      text-align: center;
      div {
        display: inline-block;
        font-size: 12px;
        color: rgb(152, 152, 152);
        a {
          text-decoration: none;
          color: rgb(152, 152, 152);
        }
        img {
          height: 12px;
          width: 12px;
          vertical-align: top;
          margin-top: 3px;
          margin-right: 6px;
        }
      }
      .line {
        vertical-align: middle;
        background: rgb(152, 152, 152);
        height: 12px;
        font-size: 12px;
        margin: 0 10px;
        width: 1px;
      }
    }
  }
}
#contestInformation/deep/.el-pagination .btn-next,
#contestInformation/deep/ .el-pagination .btn-prev {
  background-color: transparent;
}
#contestInformation/deep/.el-pager li {
  background-color: transparent;
}
#contestInformation/deep/.el-pager li.active {
  color: #4576d4;
}
</style>
